import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=15dcbeb5&scoped=true&"
import script from "./loginModal.vue?vue&type=script&lang=js&"
export * from "./loginModal.vue?vue&type=script&lang=js&"
import style0 from "./loginModal.vue?vue&type=style&index=0&id=15dcbeb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dcbeb5",
  null
  
)

export default component.exports